export default __webpack_public_path__ + "static/media/facebook-logo.177b9764.svg";